import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'documentType',
})
export class DocumentTypePipe implements PipeTransform {
  transform(value: any): any {
    return value.charAt(0);
  }
}
